import { IDmNguonBietToiType } from "../../../models/response/category/IDmNguonBietToiType";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objNguonBietToiTypeDefine = {
    LOAD_START: "",
    LOAD_SUCCESS: [] as IDmNguonBietToiType[],
    LOAD_ERROR: "",
    SHOW_EDIT_MODAL: {} as IDmNguonBietToiType | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IDmNguonBietToiType,
    SAVE_SUCESS: {} as IDmNguonBietToiType,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eNguonBietToiTypeActionTypeIds = generateActionTypeIds(objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE")
export type INguonBietToiTypeActionTypes = IGenericActionType<typeof objNguonBietToiTypeDefine, "NGUON_BIET_TOI_TYPE">
